module.exports = __webpack_public_path__ + "img/dice-d10.061b4709.svg";